/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-article-page.js · one blog article, after it has loaded
   (launch wave, key "search", 10-10-2026). sections/ce-main-article.liquid ([data-ce-ar]). No dependencies; deferred.
   1. Tidy the editor's leftovers in the article body (empty <p>&nbsp;</p> spacers, a photo floated in the editor,
      a table that is wider than a phone gets a scrolling frame, a YouTube / Vimeo embed gets a 16:9 frame). The words
      are never changed.
   2. "On this page": built from the article's own h2 / h3 when there are enough of them (data-ce-ar-min); the one you
      are reading is marked as you scroll. Phones: it folds above the article and closes after a pick.
   3. Copy link: the button shows only where the clipboard can be used.
   ========================================================================================== */
(() => {
  'use strict';
  if (window.CEArticlePage) return;
  window.CEArticlePage = true;
  const D = document;
  const slug = (t) => t.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'part';
  const blank = (el) => !el.textContent.replace(/[\s ​]/g, '');

  const tidy = (body) => {
    body.querySelectorAll('p, h1, h2, h3, h4, h5, h6').forEach((el) => {
      if (blank(el) && !el.querySelector('img, iframe, video, svg, input, button, embed, object')) el.remove();
    });
    body.querySelectorAll('img').forEach((img) => {
      const f = (img.style.cssFloat || img.getAttribute('align') || '').toLowerCase();
      if (f === 'right' || f === 'left') img.classList.add('ce-rte-float', `ce-rte-float--${f}`);
      let p = img.parentElement;
      while (p && p !== body && /^(A|STRONG|B|SPAN|EM)$/.test(p.tagName)) p = p.parentElement;
      if (p && p !== body && p.tagName === 'P' && blank(p) && p.querySelectorAll('img').length === 1) p.classList.add('ce-rte-figure');
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('alt')) img.setAttribute('alt', '');
    });
    body.querySelectorAll('table').forEach((t) => {
      if (t.parentElement.classList.contains('ce-rte-table')) return;
      const w = D.createElement('div');
      w.className = 'ce-rte-table';
      w.tabIndex = 0;
      w.setAttribute('role', 'region');
      w.setAttribute('aria-label', t.caption ? t.caption.textContent : 'Table');
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    body.querySelectorAll('iframe').forEach((f) => {
      if (!/youtube|vimeo|youtu\.be/.test(f.src) || f.parentElement.classList.contains('ce-rte-video')) return;
      const w = D.createElement('div');
      w.className = 'ce-rte-video';
      f.parentNode.insertBefore(w, f);
      w.appendChild(f);
      f.removeAttribute('width');
      f.removeAttribute('height');
      if (!f.title) f.title = 'Video';
    });
  };

  const toc = (root, body) => {
    const navs = root.querySelectorAll('[data-ce-ar-toc]');
    if (!navs.length) return;
    const min = +root.getAttribute('data-ce-ar-min') || 3;
    const used = {};
    const hs = [...body.querySelectorAll('h2, h3')].filter((h) => h.textContent.replace(/[\s ]/g, '').length > 1);
    if (hs.length < min) return;
    const top = hs.some((h) => h.tagName === 'H2');
    hs.forEach((h) => {
      if (!h.id) {
        const id = `ce-${slug(h.textContent)}`;
        let k = id, i = 2;
        while (used[k] || D.getElementById(k)) k = `${id}-${i++}`;
        h.id = k;
      }
      used[h.id] = 1;
    });
    const links = [];
    navs.forEach((nav) => {
      const list = nav.querySelector('ol');
      hs.forEach((h) => {
        const li = D.createElement('li');
        const a = D.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.replace(/[\s ]+/g, ' ').replace(/:\s*$/, '').trim();
        if (top && h.tagName === 'H3') li.className = 'is-sub';
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
      nav.hidden = false;
      const box = nav.querySelector('details');
      if (box) list.addEventListener('click', (e) => { if (e.target.closest('a')) box.open = false; });
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ens) => {
        ens.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((a) => {
            if (a.getAttribute('href') === `#${en.target.id}`) a.setAttribute('aria-current', 'location');
            else a.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-18% 0px -70% 0px' });
      hs.forEach((h) => io.observe(h));
    }
  };

  const copy = (root) => {
    root.querySelectorAll('[data-ce-ar-copy]').forEach((b) => {
      if (!(navigator.clipboard && navigator.clipboard.writeText) || !window.isSecureContext) return;
      const li = b.closest('li');
      if (li) li.hidden = false;
      b.addEventListener('click', () => {
        navigator.clipboard.writeText(b.getAttribute('data-ce-ar-copy')).then(() => {
          const msg = b.getAttribute('data-ce-ar-copied') || 'Link copied';
          b.classList.add('is-copied');
          b.setAttribute('aria-label', msg);
          let tip = b.parentElement.querySelector('.ce-ar-share__tip');
          if (!tip) {
            tip = D.createElement('span');
            tip.className = 'ce-ar-share__tip';
            tip.setAttribute('role', 'status');
            b.parentElement.appendChild(tip);
          }
          tip.textContent = msg;
          setTimeout(() => { b.classList.remove('is-copied'); tip.textContent = ''; }, 2400);
        }).catch(() => {});
      });
    });
  };

  const init = (scope) => {
    (scope || D).querySelectorAll('[data-ce-ar]').forEach((root) => {
      if (root.ceAr) return;
      root.ceAr = true;
      const body = root.querySelector('[data-ce-ar-body]');
      if (body) { tidy(body); toc(root, body); }
      copy(root);
      root.classList.add('is-tidy');
    });
  };
  D.addEventListener('shopify:section:load', (e) => init(e.target));
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', () => init(D), { once: true });
  else init(D);
})();
